import React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useDataDelete from "../../../../../hooks/useDataDelete";
import {UserProfileAddressDTO} from "../../ProfilePersonalDetails";


interface ProfileAddressesDeleteModalProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    address: UserProfileAddressDTO,
    redirectToAdressSelectionInCart?: boolean,
}

const ProfileAddressesDeleteModal = ({open, setOpen, address, redirectToAdressSelectionInCart = false}: ProfileAddressesDeleteModalProps) => {
    const {deleteDataPromise} = useDataDelete(`/profile-addresses/${address.id}`, true, false);

    const handleDelete = () => {
        deleteDataPromise()
            .then((response) => {
                if (redirectToAdressSelectionInCart && !window.location.href.includes('addresses=true')) {
                    window.location.href = window.location.href+'?addresses=true';
                } else {
                    window.location.reload();
                }
            })
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    <Typography variant={"secondVariant"} fontSize={{xs: 18, sm: 20, md: 22}}>
                        Supprimer l'adresse
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Cette action est irréversible. Voulez-vous vraiment supprimer définitivement cette adresse ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Annuler</Button>
                    <Button onClick={() => handleDelete()}>
                        Confirmer
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ProfileAddressesDeleteModal